module.exports = __webpack_public_path__ + "static/media/picture_poll.36527a84.png";